import IncomeList from "../IncomeList";
import IncomeResume from "../IncomeResume";

const IncomeView = () => {
  return (
    <>
      <IncomeList />

      <IncomeResume />
    </>
  );
};

export default IncomeView;
